import { render, staticRenderFns } from "./media-uploader.vue?vue&type=template&id=1da9f93a&"
import script from "./media-uploader.vue?vue&type=script&lang=js&"
export * from "./media-uploader.vue?vue&type=script&lang=js&"
import style0 from "./media-uploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1da9f93a')) {
      api.createRecord('1da9f93a', component.options)
    } else {
      api.reload('1da9f93a', component.options)
    }
    module.hot.accept("./media-uploader.vue?vue&type=template&id=1da9f93a&", function () {
      api.rerender('1da9f93a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/uploader/media-uploader.vue"
export default component.exports